const userdemoimg = {
    demo_img : "./Images/Pages_img/userdemo.jpg"
};
export default userdemoimg;